import { useCallback, useEffect, useState } from "react";

import type { Committee } from "../../../../models/Committee";
import type { TabConfig } from "../types";
import { createTabConfigs } from "../utils";

const STORAGE_KEY = "CommitteeDecisionWrapperState";

export function useCommitteeTabPersistence(
  committees: Committee[] | undefined,
  onSaveOuterState: () => void
) {
  const [activeTabKey, setActiveTabKey] = useState<string | null>(null);
  const [tabConfigs, setTabConfigs] = useState<TabConfig[]>([]);

  useEffect(() => {
    if (!committees) return;

    const newConfigs = createTabConfigs(committees);
    setTabConfigs(newConfigs);

    const storedKey = sessionStorage.getItem(STORAGE_KEY);
    const isStoredKeyValid =
      !!storedKey && newConfigs.some((c) => c.key === storedKey);

    setActiveTabKey(
      isStoredKeyValid ? storedKey : newConfigs?.[0]?.key || null
    );
  }, [committees]);

  const handleTabChange = (key: string | null) => {
    if (!key) return;

    sessionStorage.removeItem(STORAGE_KEY);
    setActiveTabKey(key);
  };

  const onBeforeNavigate = useCallback(() => {
    if (activeTabKey) sessionStorage.setItem(STORAGE_KEY, activeTabKey);

    onSaveOuterState();
  }, [activeTabKey, onSaveOuterState]);

  return { activeTabKey, tabConfigs, handleTabChange, onBeforeNavigate };
}
